<template>
  <div class="input-text">
    <label :for="id">
      {{label}}
    </label>
    <input
      v-on="$listeners"
      v-bind="$attrs"
      :id="id"
      type="text"
      :title="label" />
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
